export default __webpack_public_path__ + "static/media/badge.9317cb08.svg";